import { DateTime } from 'luxon';

export function getCompatibleTimeZoneFrom(timeZone, compatibleTimeZones = []) {
  if (compatibleTimeZones.includes(timeZone)) {
    return timeZone;
  }

  const target = DateTime.local().setZone(timeZone);
  const timeZoneOffset = target.isValid ? target.toFormat('Z') : null;

  return compatibleTimeZones.find(compatibleTimeZone => {
    const candidate = DateTime.local().setZone(compatibleTimeZone);
    return candidate.isValid && candidate.toFormat('Z') === timeZoneOffset;
  });
}
